/************************/
   /* Inicio de min Price */
   /************************/
	(function () {
	/*
	* =========================================================
	* BOLD CUSTOM PRICING
	* =========================================================
	*/
	const boldPrices = new Map();
	// Productos que ya fueron consultados a BOLD
	const boldRequested = new Set();
	// Evita múltiples requests simultáneos
	let requestInProgress = false;
	// IDs que están esperando ser consultados
	let pendingIds = new Set();
	/*
	* ---------------------------------------------------------
	* Obtener las product cards actuales
	* ---------------------------------------------------------
	*/
	function getCards() {
		return [
		...document.querySelectorAll(
			"[data-product-item][data-product-id]"
		)
		];
	}
	/*
	* ---------------------------------------------------------
	* Obtener IDs de las cards actuales
	* ---------------------------------------------------------
	*/
	function getCurrentProductIds() {

		const gridIds = [
			...document.querySelectorAll(
				"[data-product-item][data-product-id]"
			)
		]
		.map(el => String(el.dataset.productId))
		.filter(Boolean);


		const cardIds = [
			...document.querySelectorAll(
				".money[data-product-id]"
			)
		]
		.map(el => String(el.dataset.productId))
		.filter(Boolean);


		return [
			...new Set([
				...gridIds,
				...cardIds
			])
		];

	}
	/*
	* ---------------------------------------------------------
	* Formatear precio
	* ---------------------------------------------------------
	*/
	function formatMoney(value) {
		return new Intl.NumberFormat("es-ES", {
		style: "currency",
		currency: "EUR"
		}).format(value);
	}
	/*
	* ---------------------------------------------------------
	* Pintar precios que ya tenemos en memoria
	* ---------------------------------------------------------
	*/
	function renderBoldPrices() {

		/*
		* =========================================================
		* 1. PRODUCT GRID ORIGINAL DE GLOBO
		* =========================================================
		*/

		const cards = getCards();

		cards.forEach(card => {

			const productId =
				String(card.dataset.productId);

			const minPrice =
				boldPrices.get(productId);

			/*
			* Si no existe precio mínimo BOLD,
			* no hacemos nada.
			*/
			if (minPrice === undefined) {
				return;
			}

			const container =
				card.querySelector("[data-bold-pricing]");

			const normalPrice =
				card.querySelector("[data-normal-pricing]");

			if (!container) {
				return;
			}

			const renderedPrice =
				container.dataset.boldRenderedPrice;

			if (
				renderedPrice !== String(minPrice)
			) {

				container.innerHTML = `
					<div
						class="bold-min-price"
						style="display: table-caption; font-size: large;"
					>
						<span>Desde:</span>
						<span>${formatMoney(minPrice)}</span>
					</div>
				`;

				container.dataset.boldRenderedPrice =
					String(minPrice);
			}

			container.hidden = false;

			if (normalPrice) {
				normalPrice.hidden = true;
			}

		});


		/*
		* =========================================================
		* 2. PRODUCT CARD
		* =========================================================
		*/

		const priceElements =
			document.querySelectorAll(
				".custom-bold-price[data-product-id]"
			);

		priceElements.forEach(priceElement => {

			const productId =
				String(priceElement.dataset.productId);

			const minPrice =
				boldPrices.get(productId);

			/*
			* Si BOLD no tiene precio mínimo,
			* dejamos el precio original.
			*/
			if (minPrice === undefined) {
				return;
			}

			/*
			* Buscar la product card correspondiente.
			*/
			const card =
				priceElement.closest(".testjpcr");

			if (!card) {
				return;
			}

			/*
			* Buscar precio original.
			*/
			const originalPrice =
				card.querySelector(
					".price--main .money:not(.custom-bold-price)"
				);

			/*
			* Ocultar precio original.
			*/
			if (originalPrice) {
				originalPrice.style.display = "none";
			}

			/*
			* Evitar volver a pintar.
			*/
			if (
				priceElement.dataset.boldRenderedPrice ===
				String(minPrice)
			) {
				priceElement.style.display = "";
				return;
			}

			/*
			* Mostrar precio mínimo BOLD.
			*/
			priceElement.innerHTML = `
				<span class="bold-min-label">
					Desde:
				</span>
				<span class="bold-min-value">
					${formatMoney(minPrice)}
				</span>
			`;

			priceElement.style.display = "";

			priceElement.dataset.boldRenderedPrice =
				String(minPrice);

		});

	}


	/*
	* ---------------------------------------------------------
	* Obtener los productos que todavía no conocemos
	* ---------------------------------------------------------
	*/
	function getUnknownProductIds() {

		const currentIds =
		getCurrentProductIds();

		return currentIds.filter(
		productId =>
			!boldRequested.has(productId)
		);

	}


	/*
	* ---------------------------------------------------------
	* Consultar BOLD
	* ---------------------------------------------------------
	*/
	function fetchBoldPrices(productIds) {

		if (!productIds.length) {
		return;
		}
		/*
		* Marcar inmediatamente como solicitados.
		*
		* Esto evita que otra ejecución cree
		* otra petición para los mismos productos.
		*/
		productIds.forEach(id => {
		boldRequested.add(id);
		});


		console.log(
		"BOLD: consultando productos:",
		productIds
		);


		const url =
		"https://api.boldcommerce.com/go_pre/pricerules/" +
		"curtidos-garcia.myshopify.com/rulesets" +
		"?products=" +
		productIds.join(",");


		requestInProgress = true;


		fetch(url)
		.then(response => {
			if (!response.ok) {
			throw new Error(
				`BOLD API error: ${response.status}`
			);
			}
			return response.json();
		})
		.then(data => {
			console.log(
			"BOLD RESPONSE:",
			data
			);

			/*
			* ---------------------------------------------------
			* Procesar rulesets
			* ---------------------------------------------------
			*/
			data.rulesets.forEach(ruleset => {
			const products =
				ruleset.product_selection?.products || [];
			products.forEach(product => {
				const productId =
				String(product.product_id);
				/*
				* Recorrer reglas
				*/
				ruleset.rules.forEach(rule => {
				if (
					rule.type !== "DISPLAY"
				) {
					return;
				}


				rule.actions.forEach(action => {

					if (
						action.type !==
						"DISPLAY_QTY_BREAK"
					) {
						return;
					}

					const price =
						Number(action.price) / 100;

					if (
						!Number.isFinite(price)
					) {
						return;
					}

					/*
					* Guardar solamente el precio mínimo
					*/
					if (!boldPrices.has(productId)) {

						boldPrices.set(
						productId,
						price
						);

					} else {

						const current =
						boldPrices.get(productId);

						if (price < current) {

						boldPrices.set(
							productId,
							price
						);

						}

					}

					});

				});

			});

			});


			console.log(
			"BOLD MIN PRICES:",
			boldPrices
			);


			/*
			* Pintar inmediatamente
			*/
			renderBoldPrices();

		})

		.catch(error => {

			console.error(
			"BOLD ERROR:",
			error
			);


			/*
			* Si falla la petición permitimos
			* volver a intentar esos productos.
			*/
			productIds.forEach(id => {
			boldRequested.delete(id);
			});

		})

		.finally(() => {

			requestInProgress = false;


			/*
			* Puede haber productos nuevos esperando
			* mientras la petición estaba activa.
			*/
			processPendingProducts();

		});

	}


	/*
	* ---------------------------------------------------------
	* Procesar productos nuevos
	* ---------------------------------------------------------
	*/
	function processPendingProducts() {

		const unknownIds =
		getUnknownProductIds();


		if (!unknownIds.length) {

		renderBoldPrices();

		return;

		}


		/*
		* Si ya hay una petición en progreso,
		* guardamos los IDs para después.
		*/
		if (requestInProgress) {

		unknownIds.forEach(id => {
			pendingIds.add(id);
		});

		return;

		}


		/*
		* Máximo razonable por petición.
		*
		* En una colección normal serán 20.
		*/
		const idsToRequest =
		unknownIds.slice(0, 50);


		fetchBoldPrices(idsToRequest);

	}


	/*
	* ---------------------------------------------------------
	* Inicialización
	* ---------------------------------------------------------
	*/
	processPendingProducts();


	/*
	* =========================================================
	* OBSERVADOR DE GLOBO
	* =========================================================
	*
	* Globo reemplaza dinámicamente las product cards.
	*
	* El observer no hace fetch directamente.
	* Solamente espera a que termine el render y
	* entonces comprueba si existen productos nuevos.
	*/

	let observerTimer = null;

	const observer =
		new MutationObserver(() => {

			/*
			* Si ya hay una actualización pendiente,
			* no hacemos nada.
			*/
			if (observerTimer) {
				return;
			}

			/*
			* Esperamos a que Globo termine
			* de modificar el DOM.
			*/
			observerTimer = setTimeout(() => {

				observerTimer = null;

				/*
				* Primero pintar precios BOLD
				* que ya conocemos.
				*/
				renderBoldPrices();

				/*
				* Después buscar productos nuevos.
				*/
				processPendingProducts();

			}, 150);

		});


	observer.observe(
		document.body,
		{
			childList: true,
			subtree: true
		}
	);


	})();	
	/* fin de min Price */